<div class="div-arriere-plan-action" (click)="clicAction($event)"></div>
<div class="div-global-action" (click)="clicAction($event)">
  <div id="center-square">
    <!-- <div id="blue-lines"></div> -->
    <div class="text-holder">
      <h1 class="header_title title">
        {{title}}
      </h1>
      <h1 *ngIf="firstText !== undefined" class="header_title">
        {{firstText}}
      </h1>
      <h1 *ngIf="secondText !== undefined" class="header_title">
        {{secondText}}
      </h1>
      <h1 *ngIf="thirdText !== undefined" class="header_title">
        {{thirdText}}
      </h1>
      <div class="separator"></div>
      <input *ngIf="phoneInput" type="tel" id="phone-input" placeholder="Mon numéro de téléphone"
        (change)="onPhoneEdit($event)">
    </div>

    <div class="offers-holder" *ngIf="index == 0">
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.HUSSAR-SINGULAR' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">588€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">490€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.FORMATION-2H' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">588€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">490€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.FULL-SERVICE' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">1 068€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">890€ HT</span>
      </div>
    </div>
    <div class="offers-holder" *ngIf="index == 1">
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-500-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">180€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">400€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-1000-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">240€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">600€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-5000-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">960€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">2 400€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.HUSSAR-SINGULAR' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">588€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">490€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.FORMATION-2H' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">588€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">490€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.FULL-SERVICE' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">1 068€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">890€ HT</span>
      </div>
    </div>
    <div class="offers-holder" *ngIf="index >= 2">
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-500-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">180€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">400€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-1000-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">240€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">600€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-5000-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">960€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">2 400€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.PACK-10000-SMS' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">1 800€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">4 500€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.HUSSAR-PLURAL' | translate}}</span>
        <span class="offer-price">{{'PRICE-DETAILS.QUOTE' | translate}}</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.FORMATION-PL' | translate}}</span>
        <span *ngIf="isAssoc" class="offer-price">1 068€ TTC</span>
        <span *ngIf="!isAssoc" class="offer-price">490€ HT</span>
      </div>
      <div class="offer-line">
        <span class="offer-text">{{'PRICE-DETAILS.FULL-SERVICE' | translate}}</span>
        <span class="offer-price">{{'PRICE-DETAILS.QUOTE' | translate}}</span>
      </div>
    </div>

    <!-- (change)="onPhoneEdit($event)" -->

    <div *ngIf="phoneInput" class="button-holder">
      <button id="button-cancel" class="phone-cancel" (click)="cancelDetails(false)">{{'PRICE-DETAILS.CANCEL' |
        translate}}</button>
      <button *ngIf="isPhoneValid" id="button-vote" class="button-blue" (click)="sendContactPhone()">{{'PRICE-DETAILS.RECALL' |
        translate}}</button>
      <button *ngIf="!isPhoneValid" id="button-vote-invalid">{{'PRICE-DETAILS.RECALL' | translate}}</button>
    </div>

    <div *ngIf="!phoneInput" class="button-holder-popup">
      <button *ngIf="cancelButton" type="button" id="button-cancel" (click)="cancelDetails(false)">
        {{'OFFERS.WARNING.CANCEL' | translate}}
      </button>
      <button *ngIf="modifyButton" type="button" id="button-cancel" (click)="cancelDetails(false)">
        {{'POLL-WARNING.CANCEL' | translate}}
      </button>
      <button *ngIf="validateButton" type="button" id="button-vote" class="button-blue" (click)="launch()">
        {{'OFFERS.WARNING.CONFIRM' | translate}}
      </button>
      <button *ngIf="understoodButton" type="button" id="button-vote" (click)="cancelDetails(true)">
        {{'DETAILS-CONTACT.UNDERSTOOD' | translate}}
      </button>
      <button *ngIf="callButton" type="button" id="button-vote" class="button-blue" (click)="cancelDetails(true)">
        {{'PRICE-DETAILS.RECALL' | translate}}
      </button>
      <button *ngIf="confirmButton" type="button" id="button-vote" class="button-blue" (click)="cancelDetails(true)">
        {{'POLL-WARNING.CLOSE' | translate}}
      </button>
      <div *ngIf="votingAvailableButtons" style="display: flex; flex-direction: column">
        <button type="button" id="button-vote" class="button-blue" (click)="cancelDetails(true)">
          {{'POLL-WARNING.CLOSE-AVAILABLE' | translate}}
        </button>
        <button type="button" id="button-cancel" (click)="cancelDetails(false)">
          {{'POLL-WARNING.CANCEL-AVAILABLE' | translate}}
        </button>
      </div>
    </div>
</div>
